import type { FaireProductEntity } from "../../entity_types/product";

export const p_jkfxc7jhsg: FaireProductEntity = {
  token: "p_jkfxc7jhsg",
  type: "product",
  name: "Coastal: Novelty Mahjong Playing Card (Set of 4)",
  brandToken: "b_m2upumjee3",
  brandName: "Mahjong & Magnolias",
  imageUrl:
    "https://cdn.faire.com/fastly/f5bd2285438dbba5566557863e1f5d8eeb968761cd585e6c531247977a342bb2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e36ca194bba811e09c70a78028dc48f4d5edd2d94e92e76a732fe4b7e513a456.jpeg",
    "https://cdn.faire.com/fastly/86655fd0b5f7691070245ab5a9de4a8a71645d39f527b6faad871261f364601f.jpeg",
  ],
  priceDollars: 24,
  description:
    "A delightful alternative to the standard National Mahjong League card.  Our cards use the same tiles and the same rules as American Mahjong but a unique legendOur cards have a wordplay twist and use tiles to spell words like Beach, Tote Bag and of course Caftan!\n\nThese matte laminated cards are sold in sets of four so the whole group is ready to play.\n\nCheck out our video to hear more.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:49.597Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
